/**
 * Converts false booleans to undefined so they are omitted from URL search params.
 * If value is undefined, uses fallback instead.
 */
const toSearchFlag = (value?: boolean, fallback?: boolean): true | undefined => {
  return value ?? fallback ? true : undefined;
};

export default toSearchFlag;
